export default "__VITE_ASSET__LPg_LqsV__"